var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{on:{"click":_vm.showSummary}},[_c('Header'),_c('router-view'),_c('Error'),(_vm.isDev)?_c('Ribbon'):_vm._e(),_c('Footer'),_c('Theme')],1)}
var staticRenderFns = []

export { render, staticRenderFns }